<table class="table">
  <thead>
  <tr>
    <th>
      {{'lang.globals.name' | translate}}
    </th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let medium of media">
    <td>
      <sb-comp-image-name-wrapper [medium]="medium">
        <span firstLine>
          {{ medium?.name }}
        </span>
      </sb-comp-image-name-wrapper>
    </td>
  </tr>
  </tbody>
</table>
